export default "__VITE_ASSET__f509fcc5__"